class PlaceSearcher {

    constructor() {
        this.types = [
            {
                title: 'Kreis',
                place_type_ids: [7,8,9],
                inputs: ['name'],
                article: 'dem',
                no: 'keinen'
            },
            {
                title: 'kreisfreie Stadt',
                place_type_ids: [20,21,22],
                inputs: ['name'],
                article: 'der',
                no: 'keine'
            },
            {
                title: 'Stadt',
                place_type_ids: [20,21,22,23,27],
                inputs: ['name'],
                article: 'der',
                no: 'keine'
            },
            {
                title: 'Samtgemeinde / Amt',
                place_type_ids: [12,13,14,15,16,17,18],
                inputs: ['name'],
                article: 'der',
                no: 'keine'
            },
            {
                title: 'Gemeinde',
                place_type_ids: [19],
                inputs: ['name'],
                article: 'der',
                no: 'keine'
            },
            {
                title: 'Ortsteil / Stadtbezirk',
                place_type_ids: [28],
                inputs: ['name'],
                article: 'dem',
                no: 'keinen'
            },
        ]
    }

    init() {
        this.$searchMask = $("#search-mask");
        this.$form = this.$searchMask.find("#search-place");

        if (!this.$form.length) {
            return;
        }

        this.initElements();
        this.initCurrentPlace();
        this.initTypeChooser();
        this.initFormSubmit();
    }

    resetForm() {
        this.$requestErrorAlert.hide();
        this.$nothingFoundAlert.hide();
        this.$inputAlert.hide();

        this.$resultContainer.find(".result").not(".template").remove();
    }

    initElements() {
        this.$zipInput = this.$searchMask.find("input[name='zip']");
        this.$nameInput = this.$searchMask.find("input[name='name']");
        this.$inputAlert = this.$searchMask.find(".alert");

        this.$searchResults = $("#search-results");
        this.$requestErrorAlert = this.$searchResults.find(".alert-danger");
        this.$nothingFoundAlert = this.$searchResults.find(".alert-info");
        this.$resultContainer = this.$searchResults.find("#result-container");
        this.$resultTemplate = this.$resultContainer.find(".template");
        this.$foundMessage = this.$searchResults.find(".found");
        this.$loading = this.$searchResults.find("#loading");
        this.$radioContainer = $("#place-type-radio");

        this.$step1Form = $("#step-1-form");

        this.$step1Form.find(".btn-primary")
            .prop("disabled", true)
            .attr("title", "Bitte wählen Sie zunächst einen Ort aus!");

        this.$hiddenInput = $("input#place-id");

        this.initRadioButtons();
        this.$typeChooser = $("input[name='place_type']");

        this.wrapper = $('.place-searcher');
    }

    initRadioButtons() {
        for (const [index, type] of this.types.entries()) {
            let $radio = '<div class="form-check">' +
                '<input type="radio" name="place_type" value="' + index + '" id="place-type-' + index + '" class="form-check-input">' +
                '<label class="form-check-label" for="place-type-' + index + '">' + type.title + '</label>' +
                '</div>';

            this.$radioContainer.append($radio);
        }
    }

    initTypeChooser() {
        this.$typeChooser.on("change", (event) => {
            let type = this.getChosenType();

            this.$nameInput.closest('.form-group').hide();
            this.$zipInput.closest('.form-group').hide();

            let inputs = [];

            if (type.inputs.includes('plz')) {
                this.$zipInput.closest('.form-group').show();
                inputs.push('der Postleitzahl');
            }
            if (type.inputs.includes('name')) {
                this.$nameInput.closest('.form-group').show();
                inputs.push('des Namens');
            }

            let inputText = "" + inputs[0] + (!inputs[1] ? "" : " oder " + inputs[1]);

            $(".chosen-place-type").html(type.article + " " + type.title);
            $(".chosen-place-type-error").html(type.no + " " + type.title);
            $(".chosen-place-inputs").html(inputText);

            this.$searchMask.slideDown();

            this.$nothingFoundAlert.hide();
            this.$foundMessage.hide();
        });
    }

    getChosenType() {
        let val = this.$typeChooser.filter(':checked').val();
        let type = null;
        for (const [index, typeEntry] of this.types.entries()) {
            if (val === index.toString()) {
                type = typeEntry;
            }
        }
        return type;
    }

    initFormSubmit() {
        this.$form.on("submit", (event) => {
            event.preventDefault();
            this.resetForm();

            if (this.$zipInput.val().trim() === "" && this.$nameInput.val().trim() === "") {
                this.$inputAlert.show();
                return;
            }

            this.$loading.show();

            let type = this.getChosenType();

            $.post(this.$form.attr("action"), {
                zip: this.$zipInput.val(),
                name: this.$nameInput.val(),
                place_type_ids: type.place_type_ids
            }, (data) => {
                this.$loading.hide();

                if (!data.status) {
                    this.$requestErrorAlert.show();
                }
                else {
                    if (!data.found) {
                        this.$nothingFoundAlert.show();
                        this.$foundMessage.hide();
                    }
                    else {
                        this.drawResults(data.places);
                    }
                }
            });
        });
    }

    drawResults(results) {
        this.$foundMessage.show();

        results.forEach((place) => {
            let element = this.$resultTemplate.clone();
            element.removeClass("template");
            element.find("input").attr("value", place.id);

            for (let key in place) {
                let span = element.find("[data-column='" + key + "']");
                if (span.length && place.hasOwnProperty(key)) {
                    span.html(place[key]);
                }
            }

            this.$resultContainer.append(element.show());
        });

        this.$resultContainer.slideDown();
        this.initResultRadio();
    }

    initResultRadio() {
        this.$resultContainer.find("input").on("change", (event) => {
            this.$hiddenInput.val($(event.currentTarget).val());
            this.$step1Form.find(".btn-primary")
                .prop("disabled", false)

            let $placeText = $(event.currentTarget).parent().parent().clone();
            $placeText.children('.form-check').remove();

            if (window.localStorage) {
                window.localStorage.setItem('place_text', $placeText.html());
            }
        });
    }

    initCurrentPlace() {
        if (this.$step1Form.length && this.$hiddenInput.val() && window.localStorage) {
            $('.current-place-name').html(window.localStorage.getItem('place_text'));
            $('.current-place').show();
            this.wrapper.hide();

            this.$step1Form.find(".btn-primary")
                .prop("disabled", false)
        }

        $('.reset-place-searcher').on("click", (event) => {
            this.wrapper.show();
            $('.current-place').hide();
        });
    }
}

export default PlaceSearcher;